import { createSlice, createAction } from "@reduxjs/toolkit";
import { RootState } from "store/store";
import {
	AffiliateTransaction,
	AffiliateTransactionQueryParams,
} from "../types";
import { Purchase } from "features/purchase/types";

interface AffiliateTransactionState {
	affiliateTransactions: Array<AffiliateTransaction>;
	affiliateTransactionsTotal: number;
	affiliateTransaction?: AffiliateTransaction;
	purchase?: Purchase;
}

const initialState: AffiliateTransactionState = {
	affiliateTransactions: [],
	affiliateTransactionsTotal: 0,
};

export const affiliateTransactionSlice = createSlice({
	name: "affiliateTransaction",
	initialState,
	reducers: {
		setAffiliateTransactions: (state, action) => {
			state.affiliateTransactions = action.payload.data;
			state.affiliateTransactionsTotal = action.payload.total;
		},
		setAffiliateTransaction: (state, action) => {
			state.affiliateTransaction = action.payload.data;
		},
		setPurchase: (state, action) => {
			state.purchase = action.payload.data;
		},
	},
});

export const selectAffiliateTransactions = (state: RootState) =>
	state.affiliateTransaction.affiliateTransactions;
export const selectAffiliateTransactionsTotal = (state: RootState) =>
	state.affiliateTransaction.affiliateTransactionsTotal;
export const selectAffiliateTransaction = (state: RootState) =>
	state.affiliateTransaction.affiliateTransaction;
export const selectAffiliateTransactionPurchase = (state: RootState) =>
	state.affiliateTransaction.purchase;

export const {
	setAffiliateTransactions,
	setAffiliateTransaction,
	setPurchase,
} = affiliateTransactionSlice.actions;

export interface GetAffiliateTransactionsAsyncPayload {
	query: AffiliateTransactionQueryParams;
	callback?: () => void;
}
export interface GetAffiliateTransactionDetailsPayload {
	id: string;
	callback?: (affiliateTransaction: AffiliateTransaction) => void;
}

export interface VerifyAffiliateTransactionPayload {
	id?: string;
	callback?: () => void;
}

export const getAffiliateTransactionsAsync = createAction(
	"affiliateTransaction/getAffiliateTransactions",
	(payload: GetAffiliateTransactionsAsyncPayload) => ({
		payload: payload || {},
	}),
);

export const getAffiliateTransactionDetailsAsync = createAction(
	"affiliateTransaction/getAffiliateTransactionDetails",
	(payload: GetAffiliateTransactionDetailsPayload) => ({
		payload: payload,
	}),
);

export const verifyAffiliateTransactionAsync = createAction(
	"affiliateTransaction/verifyAffiliateTransaction",
	(payload: VerifyAffiliateTransactionPayload) => ({
		payload: payload,
	}),
);

export interface GetDetailPurchaseAsyncPayload {
	id: string;
	query: {
    language: string;
  };
	callback?: () => void;
}
export const getDetailPurchaseAsync = createAction(
	"affiliateTransaction/getDetailPurchaseAsync",
	(payload: GetDetailPurchaseAsyncPayload) => ({
		payload,
	}),
);

export default affiliateTransactionSlice.reducer;
